import Error from '../shared/error';
import Loader from '../shared/loader';
import { useExam } from '../../hooks/react-query/use-exam';
import { useStudentExam } from '../../hooks/react-query/use-student-exam';
import { useParams } from 'react-router-dom';
import Exam from './exam-info';
import ExamInfoAction from './exam-info-action';

function ExamInfoContainer() {
  const { examId } = useParams();
  const studentExamQuery = useStudentExam(examId ? parseInt(examId) : undefined);
  const examQuery = useExam(examId ? parseInt(examId) : undefined, {
    enabled: studentExamQuery.isSuccess
  });

  if (studentExamQuery.isError) return <Error errorMessage='شما دسترسی به این آزمون ندارید.' />;
  if (studentExamQuery.isLoading || examQuery.isLoading) return <Loader />;
  if (!studentExamQuery.data || !examQuery.data) return <p>آزمونی با شناسه {examId} یافت نشد.</p>;
  return (
    <Exam exam={examQuery.data}>
      <ExamInfoAction exam={examQuery.data} studentExam={studentExamQuery.data} />
    </Exam>
  );
}

export default ExamInfoContainer;
